import React from 'react';
import { MdDeleteForever } from "react-icons/md";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { removeItem } from '../../features/cartProducts/cartSlice';
import emptyImg from "../../assets/images/empty-cart.webp";
import { toggleSibar } from '../../features/someFunctionality/funSlice';
import { setAllItemsInCheckout } from '../../features/checkout/checkoutSlice';
import { useState } from 'react';
import { useEffect } from 'react';

const CartSide = () => {
    const { cartProducts, cartTotalAmount } = useSelector((state) => state.cartProducts)

    const dispatch = useDispatch();
    const handleRemove = (product) => {
        dispatch(removeItem(product))
    }

    const toggleDrawer = (anchor, value) => (event) => {
        dispatch(toggleSibar({ anchor, value }))
    };


    const handleSetToCheckout = (anchor, value) => {
        dispatch(setAllItemsInCheckout({ cartProducts, cartTotalAmount }));
        dispatch(toggleSibar({ anchor, value }));
    }

    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    let content = <h1>{translate ? "samting is wrong" : "কিছু একটা ক্রটি হয়েছে"}</h1>;
    if (cartProducts?.length === 0) {
        content = (
            <div className='h-screen '>
                <div className='flex justify-center'>
                    <img className='object-contain' src={emptyImg} alt="" />
                </div>
            </div>
        )
    }
    if (cartProducts?.length > 0) {
        content = (<>
            <div className='md:px-2 px-5 py-4'>
                {
                    cartProducts.map((item, index) => (
                        <div key={index} className='grid grid-cols-4 gap-4'>
                            <div className='grid content-center'>
                                <img src={item.cardImg} alt="" />
                            </div>
                            <div className='col-span-2 grid- content-center'>
                                <p className='pt-2 mb-2.5 font-poppins text-sm text-gray-600'>{item.name.length > 32 ? item.name.substring(32, 0) + ".." : item.name}</p>
                                <p className='k font-poppins text-gray-500 text-sm'>{item.quantity}x{item.total} {translate ? "BDT" : "টাকা"}</p>
                            </div>
                            <div className='py-2 flex justify-end'>
                                <MdDeleteForever onClick={() => handleRemove(item)} className='text-3xl text-bnd-1 cursor-pointer' />
                            </div>
                        </div>
                    ))
                }
                <div className='py-4 sticky bottom-0'>
                    <h2 className='text-lg font-poppins py-4'>{translate ? "Total" : "মোট"}: {cartTotalAmount} {translate ? "BDT" : "টাকা"}</h2>
                    <div className='py-2 flex justify-center gap-2'>
                        <Link onClick={toggleDrawer('right', false)} to="/carts" className='w-full'>
                            <button className='focus:outline-none uppercase font-popins text-md whitespace-nowrap font-semibold bg-black text-white py-2 px-4 rounded-full w-full hover:bg-bnd-1 transition duration-300'>{translate ? "view cart" : "কার্ট দেখুন"}</button>
                        </Link>
                        <Link onClick={() => handleSetToCheckout('right', false)} to="/checkout" className='w-full' >
                            <button className='focus:outline-none uppercase font-popins text-md whitespace-nowrap font-semibold bg-black text-white py-2 px-4 rounded-full w-full hover:bg-bnd-1 transition duration-300'>{translate ? "checkout" : "চেকআউট"}</button>
                        </Link>
                    </div>
                </div>
            </div>

        </>)
    }

    return content;
};

export default CartSide;